"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ScriptTag = /** @class */ (function () {
    function ScriptTag(configurations, logger) {
        this.logger = logger;
        this.configurations = configurations;
    }
    ScriptTag.prototype.getAttribute = function (attribute, scriptTag) {
        if (scriptTag && scriptTag.getAttribute(attribute)) {
            return scriptTag.getAttribute(attribute);
        }
        else {
            return null;
        }
    };
    return ScriptTag;
}());
exports.default = ScriptTag;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2NyaXB0VGFnLmpzIiwic291cmNlUm9vdCI6InNyYy8iLCJzb3VyY2VzIjpbInNyYy9saWIvdXRpbHMvc2NyaXB0VGFnLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBR0E7SUFJSSxtQkFBYSxjQUFtQyxFQUFFLE1BQWM7UUFDNUQsSUFBSSxDQUFDLE1BQU0sR0FBRyxNQUFNLENBQUE7UUFDcEIsSUFBSSxDQUFDLGNBQWMsR0FBRyxjQUFjLENBQUE7SUFDeEMsQ0FBQztJQUVNLGdDQUFZLEdBQW5CLFVBQXFCLFNBQWlCLEVBQUUsU0FBc0I7UUFDMUQsSUFBSSxTQUFTLElBQUksU0FBUyxDQUFDLFlBQVksQ0FBQyxTQUFTLENBQUMsRUFBRTtZQUNoRCxPQUFPLFNBQVMsQ0FBQyxZQUFZLENBQUMsU0FBUyxDQUFDLENBQUE7U0FDM0M7YUFBTTtZQUNILE9BQU8sSUFBSSxDQUFBO1NBQ2Q7SUFDTCxDQUFDO0lBQ0wsZ0JBQUM7QUFBRCxDQUFDLEFBaEJELElBZ0JDIn0=